import { fromJS } from 'immutable';

export default (str = window.location.hash) =>
  str
    .substring(1)
    .split('&')
    .map(param => param.split('='))
    .reduce((prev, cur) => {
      let val = cur[1];

      if (cur[0] === '') {
        return prev;
      }

      if (val === undefined || val === 'true') {
        val = true;
      } else if (val === 'false') {
        val = false;
      } else if (parseInt(val, 10).toString() === val) {
        val = parseInt(val, 10);
      }

      return prev.set(cur[0], val);
    }, fromJS({}));
